import { ReviewBankInfo } from "./ReviewBankInfo";

export default ReviewBankInfo;